import styled from "styled-components";

export const Section = styled.section`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 370px;

  margin-top: 30px;

  @media (max-width: 768px) {
    margin-top: 0;
    place-self: center;
  }
`;

export const SuccessContainer = styled.div`
  color: #0ecb00;

  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: center;

  p {
    color: #4d565c;
    font-size: 1rem;
    margin-left: 13px;
    margin-bottom: 0px;
  }
`;

export const ButtonContainer = styled.div`
  margin-top: 57.5px;
  max-width: 389.91px;
  width: 100%;
  margin-left: auto;
  margin-right: auto;

  a {
    text-decoration: none;
  }

  button {
    width: 100%;
  }

  @media (max-width: 768px) {
    margin-top: 0;
  }
`;

export const Header = styled.header`
  display: flex;
  flex-direction: column;
`;

export const CircleYellow = styled.div`
  border-radius: 100%;
  border: 5px solid ${({ theme }) => theme.colors.darkYellow};
  color: ${({ theme }) => theme.colors.darkYellow};
  margin-bottom: 23px;
  max-height: 60px;
  max-width: 60px;
  height: 60px;
  width: 60px;
  min-width: 60px;
  min-height: 60px;
  display: flex;
  place-content: center;
  place-items: center;
  svg {
    margin: auto;
  }
`;

export const HeaderContainer = styled.header`
  display: flex;
  flex-direction: column;
  span {
    font-size: 0.75rem;
    color: #5e5e5e;
    margin-bottom: 22px;
    color: ${({ theme }) => theme.colors.gray};

    display: flex;
    align-items: center;
  }

  h1 {
    font-size: 1.4375rem;
    margin-bottom: 12px;
    color: ${({ theme }) => theme.colors.blue};
  }

  h2 {
    font-size: 0.9375rem;
    margin-bottom: 18px;
    color: ${({ theme }) => theme.colors.gray};
    line-height: 30px;
    font-weight: 400px;
  }

  p {
    color: ${({ theme }) => theme.colors.black};
    font-weight: bold;
  }
`;
